import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from './Arrow';
import { BoxPlot } from './BoxPlot';
import { Circle } from './Circle';
import { DirectedEllipse } from './DirectedEllipse';
import { Ellipse } from './Ellipse';
import { Group } from './Group';
import { Line } from './Line';
import { Polygon } from './Polygon';
import { Polyline } from './Polyline';
import { Rectangle } from './Rectangle';
import { Shape } from './Shape';
import { Text } from './Text';
export const Annotation = {
    Arrow,
    Circle,
    DirectedEllipse,
    Ellipse,
    Group,
    Line,
    Rectangle,
    Shape,
    Text,
    Polyline,
    Polygon,
    BoxPlot,
};
export function Annotations(props) {
    return _jsx(_Fragment, { children: props.children });
}
//# sourceMappingURL=Annotation.js.map